import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CancellationConditionsComponent } from './cancellation-conditions.component';
import { DatePipeModule } from 'libraries/date/date.module';
import { DeltaPriceModule } from 'libraries/hotel/components/delta-price/delta-price.module';
import { LabelModule } from 'libraries/service/label/label.module';
import { HotelCurrencyModule } from 'libraries/service/hotel-currency/hotel-currency.module';
import { PenaltyModule } from 'libraries/hotel/components/penalty/penalty.module';
import { BtnModule } from 'libraries/ui_button/btn.module';
import { PricePipesModule } from 'libraries/pipes/price/price-pipes.module';
import { PricePipeModule } from 'libraries/pipes/price/price-pipe.module';
import { CancellationPipesService } from "./pipes/cancellation-pipes.service";
import { AreFreeOrFuturePipe } from "./pipes/are-free-or-futur.pipe";
import { IsFuturPipe } from "./pipes/is-futur.pipe";
import { GenerateDateWithoutPenaltyPipe } from "./pipes/generate-date-without-penalty.pipe";
import { IsFreePenaltyPipe } from "./pipes/is-free-penalty.pipe";
import { IsSameAsDateLastCancellationWithoutPenaltyPipe } from "./pipes/is-same-as-date-last-cancellation-without-penalty.pipe";
import { IsEqualKeyword } from "./pipes/is-equal-keyword";
import { HasKeywordPipe } from "./pipes/has-keyword.pipe";
import { CancellationConditionsService } from "./services/cancellation-conditions.service";
import { FontAwesomeModule } from "@fortawesome/angular-fontawesome";

@NgModule({
    imports: [
        BtnModule,
        CommonModule,
        DatePipeModule,
        DeltaPriceModule,
        HotelCurrencyModule,
        LabelModule,
        PricePipeModule,
        PricePipesModule,
        FontAwesomeModule,
        PenaltyModule,
    ],
    declarations: [
        AreFreeOrFuturePipe,
        CancellationConditionsComponent,
        GenerateDateWithoutPenaltyPipe,
        IsFreePenaltyPipe,
        IsFuturPipe,
        IsEqualKeyword,
        IsSameAsDateLastCancellationWithoutPenaltyPipe,
        HasKeywordPipe,
    ],
    exports: [
        CancellationConditionsComponent,
    ],
    providers: [
        CancellationPipesService,
        CancellationConditionsService,
    ]
})
export class CancellationConditionsModule {
}